<a
    class="fixed top-2 left-2 z-1000 -translate-y-[calc(100%+0.5rem)] rounded-sm bg-base-1 px-3 py-2 text-primary focus:translate-y-0"
    href="#main-content"
>
    Zum Hauptinhalt springen
</a>

<header class="mb-4 flex flex-col gap-0 px-8 pt-2 text-white" aria-label="Anwendungskopfzeile">
    <div class="flex h-16 items-center justify-between">
        <div class="flex shrink-0 items-center">
            <a class="flex h-16 items-center p-4" routerLink="/" aria-label="Startseite des SPE Content Store">
                <img class="h-4 w-25.25" src="assets/images/logo.svg" alt="Siemens Logo" />
            </a>
            <span class="p-3 text-base leading-5 whitespace-nowrap">SPE Content Store</span>
        </div>

        <div class="flex h-12 min-w-0 flex-1 items-center justify-end pl-2">
            <app-global-search class="h-9 min-w-0 flex-1 md:max-w-none" />
            <a
                class="hidden h-12 w-12 shrink-0 items-center justify-center text-white sm:flex"
                routerLink="/faq"
                routerLinkActive
                ariaCurrentWhenActive="page"
                aria-label="Hilfe"
            >
                <si-icon class="h-5 w-6 text-xl text-white!" [icon]="icons.elementHelp" />
            </a>
            <app-user class="shrink-0" />
        </div>
    </div>

    <nav class="flex items-center overflow-x-auto mb-2" aria-label="Hauptnavigation">
        @for (item of navItems; track item.routerLink) {
            <a
                class="flex h-8 items-center justify-center px-2! py-1! text-sm leading-4 whitespace-nowrap text-inherit no-underline! hover:bg-white/8"
                [class]="isActive(item) ? 'bg-[#001f39] text-[#00e5aa] hover:bg-[#001f39]' : ''"
                [routerLink]="item.routerLink"
                [attr.aria-current]="isActive(item) ? 'page' : null"
            >
                <span class="px-1">{{ item.label }}</span>
            </a>
        }
    </nav>
</header>
